import { Container, Divider, Grid, Segment } from "semantic-ui-react";
import IkonEnkelInvestering from "../images/IkonEnkelInvestering.svg";
import IkonLavereOmkostninger from "../images/IkonLavereOmkostninger.svg";
import IkonIngenAlternativeInvesteringer from "../images/IkonIngenAlternativeInvesteringer.svg";
import IkonFasteIndeks from "../images/IkonFasteIndeks.svg";
import "./Selvstaendige.css";

const IndeksPlus = (props) => (
  <div style={{ backgroundColor: "white" }}>
    <Container text>
      <Segment basic>
        <p>1. oktober 2026</p>
        <h2 className="trompet">INVESTERINGSFOKUS</h2>
        <h2 className="ui header" style={{ paddingTop: 0 }}>
          PFA Indeks Plus
        </h2>
      </Segment>
    </Container>

    <Container text>
      <Segment basic>
        <p className="manchet">
          I PFA Indeks Plus bliver din opsparing investeret i en bred portefølje
          af børsnoterede aktier og obligationer, der følger udvalgte fastlagte
          indeks.
        </p>
        <p>
          Det betyder, at værdien af din pensionsopsparing vil stige, hvis de
          udvalgte indeks stiger. På samme måde vil værdien af din
          pensionsopsparing falde, hvis de falder.
        </p>
        <p>
          Du kan selv vælge, hvor stor en andel af din investering, du ønsker at
          placere i PFA Indeks Plus.{" "}
        </p>

        <h3>PFA Indeks Plus er til dig, der:</h3>
        <ul>
          <li>Ønsker en enkel investeringsløsning.</li>
          <li>
            Ønsker at investere din pension i et billigere investeringsvalg med
            et lidt lavere forventet afkast.*
          </li>
          <li>
            Ikke har et ønske om at PFA løbende tilpasser investeringen af min
            opsparing til verdenssituationen.
          </li>
        </ul>
        <p>
          <i>
            * PFA Indeks Plus har et lidt lavere forventet afkast sammenlignet
            med PFA Plus.
          </i>
        </p>
      </Segment>

      <Divider hidden />
      <Segment basic style={{ backgroundColor: "#f6f0e7" }}>
        <h3 style={{ color: "#e49d3b" }}>
          Investeringsfokus, der følger udvalgte fastlagte indeks
        </h3>
        <p>
          Med PFA Indeks Plus fravælger du således aktiv forvaltning af din
          opsparing. Det betyder, at din opsparing ikke løbende vil blive
          justeret af PFA’s investeringseksperter i forhold til den aktuelle
          verdenssituation.
        </p>
        <p>
          Risikoen i PFA Indeks Plus vil være sammenlignelig med PFA Plus, men
          da produktet er mere enkelt, forventer vi, at afkastet over et
          livsforløb kan blive lavere end i PFA Plus, men i praksis kan afkastet
          dog både være højere, det samme eller lavere.{" "}
        </p>
        <p>
          Valutaen i PFA Indeks Plus Høj fonden er uafdækket, hvorfor der kan
          ske større udsving på kort sigt som følge af valutakursudsving.{" "}
        </p>
      </Segment>
      <Divider hidden />

      <Segment basic>
        <h3>Fordele ved PFA Indeks Plus</h3>
        <Divider hidden />
        <Grid centered stackable columns={2}>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonEnkelInvestering})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>En mere enkel investering</h4>
              <p>
                Med PFA Indeks Plus ved du præcis, hvordan din opsparing er
                investeret, da den følger udvalgte markedsindeks. Det er ideelt
                for dig, der ønsker en enkel løsning.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonLavereOmkostninger})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Lavere omkostninger</h4>
              <p>
                Den mere simple investeringsløsning betyder, at produktet er
                lidt billigere sammenlignet med PFA’s øvrige
                investeringsløsninger.
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        <Divider hidden />
        <h3>Hvordan adskiller PFA Indeks Plus sig?</h3>
        <p>
          PFA Indeks Plus adskiller sig fra PFA Plus og PFA Klima Plus på
          særligt to områder:
        </p>
        <Divider hidden />
        <Grid centered stackable columns={2}>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{
                  backgroundImage: `url(${IkonIngenAlternativeInvesteringer})`,
                }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Ingen alternative investeringer, herunder ejendomme mv.</h4>
              <p>
                PFA Indeks Plus afspejler underliggende markedsindeks og
                afkastet heraf. Din opsparing vil således ikke indeholde
                alternative investeringer som eksempelvis ejendomme, private
                equity og infrastruktur.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonFasteIndeks})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Produktet følger faste udvalgte indeks</h4>
              <p>
                Din opsparing vil ikke løbende blive tilpasset af PFA’s
                investeringseksperter i forhold til verdenssituationen med
                henblik på at øge afkast eller sikre beskyttelse mod store
                markedsudsving.
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        <Divider hidden />
        <h3>PFA Indeks Plus og ansvarlige investeringer</h3>
        <p>
          Investeringerne i PFA Indeks Plus er underlagt PFA’s Politik for
          ansvarlige investeringer og aktivt ejerskab. Det betyder, at der
          stilles krav til selskabernes arbejde med sociale-, miljø- og
          ledelsesmæssige forhold. Derfor kan der være tilfælde, hvor en del af
          de underliggende investeringer (aktier eller obligationer) fra et
          givent markedsindeks er blevet fravalgt af PFA, fordi disse
          investeringer ikke lever op til vores politik. Afkastet på din
          opsparing kan således afvige fra markedsafkastet.
        </p>
      </Segment>
    </Container>
  </div>
);

export default IndeksPlus;
